import { ServerName } from 'types/config';

export const getServerName = (): ServerName | null => {
  if (typeof window === 'undefined') return null;

  const hostname = window?.location?.hostname;

  if (hostname.includes('app.varicon')) return 'production';
  if (hostname.includes('staging')) return 'staging';
  if (hostname.includes('sanity')) return 'sanity';
  if (hostname.includes('app.varicontest')) return 'apptest';
  if (hostname.includes('development')) return 'dev';
  if (hostname.includes('integration')) return 'integration';
  if (hostname.includes('local')) return 'local';
  return 'local';
};
